<div class="layout-container top-bar-offset">
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
</div>
